import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import CheckoutForm from './Form';
import { Props } from './types';

const StripePaymentButton = ({ settings, createOrder, approveOrder, translation }: Props) => {
  const stripePromise = loadStripe(settings.apiKey);
  return (
    <Elements stripe={stripePromise}>
      <CheckoutForm translation={translation} createOrder={createOrder} approveOrder={approveOrder} settings={settings} />
    </Elements>
  );
};

export default StripePaymentButton;
